import React, { useState } from 'react';
import PropTypes from 'prop-types';

import UTRModal from '../../../Modal';
import SavedListModalActions from '../../../SavedLists/SavedListModalActions';
import {
    SORT_LIST_OPTIONS,
    SORT_LISTS_TITLE,
    SORT_LISTS_HEADING,
    SORT_LISTS_APPLY_LABEL,
    optionForValue,
    selectedSortValue,
} from './sortListsOptions';

import styles from './sortListsModal.scss';

// Modal. prefix per CLAUDE.md rule 4; the web verifier drives these literals.
const TESTID_PREFIX = 'modal.sort-player-lists';
const RADIO_GROUP_NAME = 'sort-player-lists';

// Mobile-only "Sort Player Lists" modal (Figma 101-6491): the four sort options as native radio rows
// (bold title over a grey description) with a pinned Cancel / Apply footer. Selection is staged locally
// and committed only on Apply (onSort(column, type)); Cancel closes with no change. Pre-selects the
// option matching the current sort on open. The desktop column-header sort is untouched (this renders
// mobile-only).
const SortListsModal = ({ sortColumn, sortType, onApply, onCancel }) => {
    const [pendingValue, setPendingValue] = useState(() => selectedSortValue(sortColumn, sortType));

    const handleApply = () => {
        const option = optionForValue(pendingValue);
        if (option) {
            onApply(option.column, option.type);
        }
    };

    return (
        <UTRModal
            title={SORT_LISTS_TITLE}
            onCloseClick={onCancel}
            className={styles.sortModal}
            data-testid={TESTID_PREFIX}
        >
            <div className={styles.heading} data-testid={`${TESTID_PREFIX}.heading`}>
                {SORT_LISTS_HEADING}
            </div>
            <div className={styles.options}>
                {SORT_LIST_OPTIONS.map((option) => {
                    const optionTestId = `${TESTID_PREFIX}.option-${option.value}`;
                    return (
                        <label
                            key={option.value}
                            className={styles.option}
                            data-testid={optionTestId}
                        >
                            <input
                                type="radio"
                                name={RADIO_GROUP_NAME}
                                className={styles.radio}
                                value={option.value}
                                checked={pendingValue === option.value}
                                onChange={() => setPendingValue(option.value)}
                                aria-label={option.title}
                                data-testid={`${optionTestId}.radio`}
                            />
                            <span className={styles.optionText}>
                                <span className={styles.optionTitle} data-testid={`${optionTestId}.title`}>
                                    {option.title}
                                </span>
                                <span className={styles.optionDescription} data-testid={`${optionTestId}.description`}>
                                    {option.description}
                                </span>
                            </span>
                        </label>
                    );
                })}
            </div>
            <SavedListModalActions
                data-testid={TESTID_PREFIX}
                onCancel={onCancel}
                onSave={handleApply}
                saveLabel={SORT_LISTS_APPLY_LABEL}
                cancelTestidSuffix="cancel-btn"
                primaryTestidSuffix="apply-btn"
                centered
                pinned
            />
        </UTRModal>
    );
};

SortListsModal.propTypes = {
    sortColumn: PropTypes.string,
    sortType: PropTypes.string,
    onApply: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

SortListsModal.defaultProps = {
    sortColumn: null,
    sortType: null,
};

export default SortListsModal;
